/**
 * Una sola pantalla de login para todos los usuarios (CRM, Company Admin, Branch Admin, Xetro Admin, Xetro Ops).
 * URL limpia /login; el POST del formulario sigue yendo a Rails (/branch/sign_in).
 */
export const LOGIN_URL = '/login';

/** Redirección a la pantalla de login. */
export function getLoginUrl(): string {
  return LOGIN_URL;
}

/** Mapea admin_level al path del dashboard React correspondiente.
 * Para `xetro_ops` con `team_role: 'account_manager'` redirige a xetro-admin. */
const DASHBOARD_PATHS: Record<string, string> = {
  xetro_admin: '/xetro-admin',
  xetro_ops: '/xetro-ops',
  company_admin: '/company-admin',
  branch_admin: '/branch-admin',
  /** Vendedores y usuarios operativos del CRM (`User::ADMIN_LEVELS` incluye `user`). */
  user: '/crm',
};

export function dashboardPathForRole(adminLevel?: string, teamRole?: string | null): string {
  if (adminLevel === 'xetro_ops' && teamRole === 'account_manager') return '/xetro-admin';
  return DASHBOARD_PATHS[adminLevel ?? ''] ?? LOGIN_URL;
}
